// Shared mapping of milestone display status to a Tailwind background-fill class for timeline dots.
// Accepts a structural display shape so callers can pass the extended `partial-paid` lifecycle
// key without widening the canonical MilestoneDerivedStatus union.

const DOT_CLASS_FOR_OVERLAY: Record<string, string> = {
  late: "bg-red-500",
  "delivered-late": "bg-amber-500",
  "due-soon": "bg-brand-500",
};

const DOT_CLASS_FOR_LIFECYCLE: Record<string, string> = {
  upcoming: "bg-slate-400",
  delivered: "bg-sky-500",
  "partially-accepted": "bg-sky-500",
  // Accepted = open emerald circle: matches the inline-legend swatch
  // ("Accepted (awaiting payment)") so the timeline and the legend
  // describe the same state with the same shape. `border-2` keeps the
  // outline visible at 10px diameter; bg-white in light mode and
  // bg-slate-800 in dark mode hollow the dot.
  accepted: "border-2 border-emerald-500 bg-white dark:bg-slate-800",
  paid: "bg-emerald-600",
  // Hex literals instead of theme() to avoid Tailwind JIT theme() resolution brittleness.
  // Emerald-500 = #10b981, Amber-500 = #f59e0b.
  "partial-paid": "bg-[linear-gradient(90deg,#10b981_50%,#f59e0b_50%)]",
};

export function dotClass(display: { lifecycle: string; riskOverlay?: string }): string {
  if (display.riskOverlay && DOT_CLASS_FOR_OVERLAY[display.riskOverlay]) {
    return DOT_CLASS_FOR_OVERLAY[display.riskOverlay];
  }
  return DOT_CLASS_FOR_LIFECYCLE[display.lifecycle] ?? "bg-slate-400";
}
